import { RowTrackingDto } from "@/dtos/tracking/tracking.dto";
import { Tracking } from "@/entities";
import { formatGenericDate, parseToLocalDateTimeFromUtc, parseToTime } from "@/helpers/utilities";
import { MapCoordinate } from "@/ui/components/maps/common/interfaces/map-coordinate";
import { MapLine } from "@/ui/components/maps/common/interfaces/map-line";


export const formatTrackingToMapLine = (trackings: Tracking[]): MapLine => {
    const coords = trackings.filter(x => x.coordinates?.latitude && x.coordinates?.longitude);
    const coordinates = coords.map(x => {
        const coord: MapCoordinate = {
            name: x.id,
            coordinate: [x.coordinates?.longitude, x.coordinates?.latitude],
            isPrimaryColor: true
        }
        return coord;

    });

    const mapLine: MapLine = {
        identification: 'tracking-' + (trackings[0]?.id ?? 0),
        coordinates: coordinates
    }

    return mapLine;
}

export const formatRowTrackingDto = (trackings: Tracking[]): RowTrackingDto[] => {
    const coords = trackings.filter(x => x.coordinates?.latitude && x.coordinates?.longitude);
    return coords.map(x => {
        const datetime = parseToLocalDateTimeFromUtc(x.date + " " + x.hour)
        const row: RowTrackingDto = {
            id: x.id,
            date: formatGenericDate(datetime),
            hour: parseToTime(datetime),
            speed: x.speed,
            event: x.details.event ?? '',
            course: x.course,
            coordinates: x.coordinates,
            date_time_created: parseToLocalDateTimeFromUtc(x.created_at.toString()),
            gps_label: (x.details?.gps && x.details.gps == 1) ? 'Buena' : 'Mala',
            gsm_label: (x.details?.gsm && x.details?.gsm == 1) ? 'Buena' : 'Mala',
            bat_has_label: (x.details?.bat_has && x.details?.bat_has == 1) ? 'Si' : 'No',
            bat_per_label: (x.details?.bat_per) ?? 0,
            version_code: x.version_code
        }

        return row;
    });
}

export const formatTrackingToMapCoordinate = (tracking: Tracking): MapCoordinate => {
    const mapCoordinate: MapCoordinate = {
        name: `Bus-${tracking.id}-${tracking.date}`,
        coordinate: [tracking.coordinates.longitude, tracking.coordinates.latitude],
    }

    return mapCoordinate;
}